module.exports = __webpack_public_path__ + "img/internal_catalogue.d696d8ab.svg";